module.exports = __webpack_public_path__ + "img/apvertise-icon.01271793.svg";